import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { DialogContentText, List, ListItem, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./footerStyle.js";

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import ZKTecoLogo from '../../images/ZKTeco_Gray-Green.png';
import './DevFooterStyle.css'

import { useTranslation } from 'react-i18next';


const useStyles = makeStyles(styles);

// const styles = (theme) => ({
//   root: {
//     margin: 0,
//     padding: theme.spacing(2),
//   },
//   closeButton: {
//     position: 'absolute',
//     right: theme.spacing(1),
//     top: theme.spacing(1),
//     color: theme.palette.grey[500],
//   },
// });


 


const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function Footer(props) {
  const classes = useStyles();
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  
  const [contactUsOpen, setcontactUsOpen] = React.useState(false);
  const handleClickcontactUs = () => {
    setcontactUsOpen(true);
  };
  const handleClosecontactUs = () => {
    setcontactUsOpen(false);
  };

  const [open, setOpen] = React.useState(false);
  const handleClickOpenDevTermsConditions = () => {
    setOpen(true);
  };
  const handleClickCloseDevTermsConditions = () => {
    setOpen(false);
  };

  const [privacyPolicyOpen, setPrivacyPolicyOpen] = React.useState(false);
  const handleClickOpenPrivacyPolicy = () => {
    setPrivacyPolicyOpen(true);
  };
  const handleClosePrivacyPolicy = () => {
    setPrivacyPolicyOpen(false);
  };
  
  const { t } = useTranslation();
  return (
    <div className="devFooterStyle">
      <footer className={footerClasses} style={{position:'fixed',bottom:0,width:'100%',backgroundColor:"#0099FF",padding:0}}>
        <div className={classes.container}>
          <div className={classes.left} style={{padding:0,color:'white'}}>
            <List className={classes.list}>
              <ListItem className={classes.inlineBlock}>
                <a
                  className={classes.block}
                  onClick={handleClickcontactUs}
                  // onClick={handleClickOpen}
                  // target="_blank"
                  style={{textDecoration:"underline", cursor:"pointer"}} 
                >
                  {t("contactInfo")}
                </a>
              </ListItem>
            </List>
          </div>

          <Dialog style={{ textAlign: "center", zIndex:"999999" }}
            open={contactUsOpen}
            // onClose={this.handleDeleteDialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title">{"Contact Us?"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <p>ZKTeco India Global R&D Centre,<br />
                Survey No 01/01, Outer Ring Road,<br />
                Opposite to More Mega Store, Mahadevpura,<br />
                Bengaluru, Karnataka – 560048.<br />
                <b>platformsupport@zkteco.in</b></p>
              </DialogContentText>
            </DialogContent>
            <div style={{ marginRight: "35%" }}>
              <DialogActions >
                <Button 
                  onClick={handleClosecontactUs}
                  variant="contained" color="primary">
                  Close
                </Button>
              </DialogActions>
            </div>
          </Dialog>
          <Box component="div" alignItems="center" justifyContent="center" p={0}
          className={classes.center}
          style={{display:"inline-block !important"}}>
            {/* <p className="powered-by">  */}
            Powered by 
            <img src={ZKTecoLogo} className="zkteco-logo" alt="ZKTeco Logo" />
          {/* </p> */}
          </Box>
          <div className={classes.right} style={{padding:0,color:'white'}}>
            <List className={classes.list}>
              <ListItem className={classes.inlineBlock}>
                  <a
                    className={classes.block}
                    onClick={handleClickOpenDevTermsConditions}
                    style={{textDecoration:"underline", cursor:"pointer"}}
                  >
                    {t("termsAndConditions")}
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    // href="#"
                    className={classes.block}
                    onClick={handleClickOpenPrivacyPolicy}
                    // target="_blank"
                    style={{textDecoration:"underline", cursor:"pointer"}}
                  >
                    {t("privacyPolicy")}
                  </a>
                </ListItem>
                {/* <ListItem className={classes.inlineBlock}>
                  <a
                    href="#"
                    className={classes.block}
                    target="_blank"
                  >
                    Licenses
                  </a>
                </ListItem> */}
              </List>
          </div>
        </div>

        {/* Terms & Conditions Dialog Starts Here */}
        <div>
          <Dialog onClose={handleClickCloseDevTermsConditions} aria-labelledby="customized-dialog-title" open={open}  style={{zIndex:"999999"}}>
            <DialogTitle id="customized-dialog-title" style={{textAlign:"center"}}>
              Terms and Conditions of Use
            </DialogTitle>
            <DialogContent dividers>
              <Typography variant="h6" component="h2" gutterBottom>
                <ol>
                  <li>
                    <b>Introduction</b>
                    <ol>
                      <li>These terms and conditions shall govern your use of our Cloud service.</li>
                      <li>By using our cloud service, you accept these terms and conditions in full; accordingly, if you disagree with these terms and conditions or any part of these terms and conditions, you must not use our (ZKTeco) cloud service.</li>
                      <li>If you register with our cloud service, submit any material to our Cloud Service or use any of our cloud services, we will ask you to expressly agree to these terms and conditions.</li>
                      <li>You must be at least 18 years of age to use our Cloud Service; by using our Cloud Service or agreeing to these terms and conditions, you warrant and represent to us (ZKTeco) that you are at least 18 years of age.</li>
                    </ol>  
                  </li>
                  <br />
                  <li>
                    <b>Credit</b>
                    <ol>
                      <li>This document was created using a template from SEQ Legal. (<a href="https://seqlegal.com" target="_blank" rel="noopener noreferrer">https://seqlegal.com</a>)</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Copyright Notice</b>
                    <ol>
                      <li>Copyright (c) 2020 ZKTeco Global.</li>
                      <li>Subject to the express provisions of these terms and conditions:
                        <ol>
                          <li>We, together with our licensors, own and control all the copyright and other intellectual property rights in our Cloud Service and the material on our Cloud Service; and</li>
                          <li>All the copyright and other intellectual property rights in our Cloud Service and the material on our Cloud Service are reserved.</li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Permission to use Cloud Service</b>
                    <ol>
                      <li>You may:
                        <ol>
                          <li>View pages from our Cloud Service in a Web browser;</li>
                          <li>Download pages from our Cloud Service for caching in a Web browser;</li>
                          <li>Print pages from our Cloud Service for your own personal and non-commercial use, provided that such printing is not systematic or excessive;</li>
                          <li>Stream audio and video files from our Cloud Service using the media player on our Cloud Service; and</li>
                          <li>Use our Cloud Service services by means of a Web browser, subject to the other provisions of these terms and conditions.</li>
                        </ol>
                      </li>
                      <li>Except as expressly permitted by Section 4.1 or the other provisions of these terms and conditions, you must not download any material from our Cloud Service or save any such material to your computer.</li>
                      <li>You may only use our Cloud Service for your personal and business purposes; you must not use our Cloud Service for any other purposes.</li>
                      <li>Except as expressly permitted by these terms and conditions, you must not edit or otherwise modify any material on our Cloud Service.</li>
                      <li>Unless you own or control the relevant rights in the material, you must not:
                        <ol>
                          <li>Republish material from our Cloud Service (including republication on another Cloud Service);</li>
                          <li>Sell, rent or sub-license material from our Cloud Service;</li>
                          <li>Show any material from our Cloud Service in public;</li>
                          <li>Exploit material from our Cloud Service for a commercial purpose; or</li>
                          <li>Redistribute material from our Cloud Service.</li>
                        </ol>
                      </li>
                      <li>Notwithstanding Section 4.5, you may redistribute our newsletter in print and electronic form to any person.</li>
                      <li>We reserve the right to suspend or restrict access to our Cloud Service, to areas of our Cloud Service and/or to functionality upon our Cloud Service. We may, for example, suspend access to the Cloud Service during server maintenance or when we update the Cloud Service. You must not circumvent or bypass, or attempt to circumvent or bypass, any access restriction measures on the Cloud Service.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Misuse of Cloud Service</b>
                    <ol>
                      <li>You must not:
                        <ol>
                          <li>Use our Cloud Service in any way or take any action that causes, or may cause, damage to the Cloud Service or impairment of the performance, availability, accessibility, integrity, or security of the Cloud Service;</li>
                          <li>Use our Cloud Service in any way that is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent, or harmful purpose or activity;</li>
                          <li>Hack or otherwise tamper with our Cloud Service;</li>
                          <li>Probe, scan, or test the vulnerability of our Cloud Service without our permission;</li>
                          <li>Circumvent any authentication or security systems or processes on or relating to our Cloud Service;</li>
                          <li>Use our Cloud Service to copy, store, host, transmit, send, use, publish or distribute any material which consists of or is linked to any spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit, or other malicious computer software;</li>
                          <li>Impose an unreasonably large load on our Cloud Service resources including bandwidth, storage capacity, and processing capacity;</li>
                          <li>Decrypt or decipher any communications sent by or to our Cloud Service without our permission;</li>
                          <li>Conduct any systematic or automated data collection activities (including without limitation scraping, data mining, data extraction, and data harvesting) on or in relation to our Cloud Service without our express written consent;</li>
                          <li>Access or otherwise interact with our Cloud Service using any robot, spider, or other automated means, except for the purpose of search engine indexing;</li>
                          <li>Use our Cloud Service except by means of our public interfaces;</li>
                          <li>Use data collected from our Cloud Service for any direct marketing activity including without limitation email marketing, SMS marketing, telemarketing, and direct mailing; or</li>
                          <li>Do anything that interferes with the normal use of our Cloud Service.</li>
                        </ol>
                      </li>
                      <li>You must not use the data collected from our Cloud Service to contact individuals, companies, or other persons or entities.</li>
                      <li>You must ensure that all the information you supply to us through our Cloud Service, or in relation to our Cloud Service, is true, accurate, current, complete, and non-misleading.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Registration and Accounts</b>
                    <ol>
                      <li>To be eligible for an account on our Cloud Service under this Section 6, you must be a client, customer, or end customer with ZKTeco.</li>
                      <li>You may register for an account with our Cloud Service by completing and submitting the account registration form on our Cloud Service.</li>
                      <li>You must not allow any other person to use your account to access the Cloud Service.</li>
                      <li>You must notify us in writing immediately if you become aware of any unauthorized use of your account.</li>
                      <li>You must not use any other person's account to access the Cloud Service unless you have that person's express permission to do so.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>User Login Details</b>
                    <ol>
                      <li>If you register for an account with our cloud service, we will make your Email as your user ID and password as entered by your choice.</li>
                      <li>Your user ID must not be liable to mislead and must comply with the content rules set out in Section 10; you must not use your account or user ID for or in connection with the impersonation of any person.</li>
                      <li>You must keep your password confidential.</li>
                      <li>You must notify us in writing immediately if you become aware of any disclosure of your password.</li>
                      <li>You are responsible for any activity on our Cloud Service arising out of any failure to keep your password confidential and may be held liable for any losses arising out of such a failure.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Modification of Account</b>
                    <ol>
                      <li>We may:
                        <ol>
                          <li>Edit your account details, at any time in our sole discretion with or without notice to you.</li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Our Rights to Use Your Content</b>
                    <ol>
                      <li>In these terms and conditions, "your content" means all works and materials (including without limitation text, graphics, images, audio material, video material, audio-visual material, scripts, software, and files) that you submit to us or our Cloud Service for storage or publication on, processing by, or transmission via, our Cloud Service.</li>
                      <li>You grant to us a worldwide, irrevocable, non-exclusive, royalty-free license to use, reproduce, store, adapt, publish, translate and distribute your content in any existing or future media OR reproduce, store and publish your content on and in relation to this Cloud Service and any successor Cloud Service OR reproduce, store and, with your specific consent, publish your content on and in relation to this Cloud Service.</li>
                      <li>You grant us the right to sub-license the rights licensed under Section 9.2.</li>
                      <li>You grant to us the right to bring an action for infringement of the rights licensed under Section 9.2.</li>
                      <li>You hereby waive all your moral rights in your content to the maximum extent permitted by applicable law; and you warrant and represent that all other moral rights in your content have been waived to the maximum extent permitted by applicable law.</li>
                      <li>You may edit your content to the extent permitted using the editing functionality made available on our Cloud Service.</li>
                      <li>Without prejudice to our other rights under these terms and conditions, if you breach any provision of these terms and conditions in any way, or if we reasonably suspect that you have breached these terms and conditions in any way, we may delete, unpublish or edit any or all of your content.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Rules About Your Content</b>
                    <ol>
                      <li>You warrant and represent that your content will comply with these terms and conditions.</li>
                      <li>Your content must not be illegal or unlawful, must not infringe any person's legal rights, and must not be capable of giving rise to legal action against any person (in each case in any jurisdiction and under any applicable law).</li>
                      <li>Your content, and the use of your content by us in accordance with these terms and conditions, must not:
                        <ol>
                          <li>Be libelous or maliciously false;</li>
                          <li>Be obscene or indecent;</li>
                          <li>Infringe any copyright, moral right, database right, trade mark right, design right, right in passing off or other intellectual property rights;</li>
                          <li>Infringe any right of confidence, right of privacy, or right under data protection legislation;</li>
                          <li>Constitute negligent advice or contain any negligent statement;</li>
                          <li>Constitute an incitement to commit a crime, instructions for the commission of a crime or the promotion of criminal activity;</li>
                          <li>Be in contempt of any court or breach of any court order;</li>
                          <li>Be in breach of racial or religious hatred or discrimination legislation;</li>
                          <li>Be blasphemous;</li>
                          <li>Be in breach of official secrets legislation;</li>
                          <li>Be in breach of any contractual obligation owed to any person;</li>
                          <li>Depict violence in an explicit, graphic or gratuitous manner;</li>
                          <li>Be pornographic, lewd, suggestive, or sexually explicit;</li>
                          <li>Be untrue, false, inaccurate or misleading;</li>
                          <li>Consist of or contain any instructions, advice, or other information which may be acted upon and could, if acted upon, cause illness, injury or death, or any other loss or damage;</li>
                          <li>Constitute spam;</li>
                          <li>Be offensive, deceptive, fraudulent, threatening, abusive, harassing, anti-social, menacing, hateful, discriminatory or inflammatory; or</li>
                          <li>Cause annoyance, inconvenience, or needless anxiety to any person.</li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Limited Warranties</b>
                    <ol>
                      <li>We do not warrant or represent:
                        <ol>
                          <li>The completeness or accuracy of the information published on our Cloud Service;</li>
                          <li>That the material on the Cloud Service is up to date;</li>
                          <li>That the Cloud Service will operate without fault; or</li>
                          <li>That the Cloud Service or any service on the Cloud Service will remain available.</li>
                        </ol>
                      </li>
                      <li>We reserve the right to discontinue or alter any or all of our Cloud Service services, and to stop publishing our Cloud Service, at any time in our sole discretion without notice or explanation; and save to the extent expressly provided otherwise in these terms and conditions, you will not be entitled to any compensation or other payment upon the discontinuance or alteration of any Cloud Service services, or if we stop publishing the Cloud Service.</li>
                      <li>To the maximum extent permitted by applicable law and subject to Section 12.1, we exclude all representations and warranties relating to the subject matter of these terms and conditions, our Cloud Service, and the use of our Cloud Service.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Limitations and Exclusions of Liability</b>
                    <ol>
                      <li>Nothing in these terms and conditions will:
                        <ol>
                          <li>Limit or exclude any liability for fraud or fraudulent misrepresentation;</li>
                          <li>Limit any liabilities in any way that is not permitted under applicable law, or</li>
                          <li>Exclude any liabilities that may not be excluded under applicable law.</li>
                        </ol>
                      </li>
                      <li>The limitations and exclusions of liability set out in this Section 12 and elsewhere in these terms and conditions:
                        <ol>
                          <li>Are subject to Section 12.1; and</li>
                          <li>Govern all liabilities arising under these terms and conditions or relating to the subject matter of these terms and conditions, including liabilities arising in contract, in tort (including negligence), and for breach of statutory duty, except to the extent expressly provided otherwise in these terms and conditions.</li>
                        </ol>
                      </li>
                      <li>To the extent that our Cloud Service and the information and services on our Cloud Service are provided free of charge, we will not be liable for any loss or damage of any nature.</li>
                      <li>We will not be liable to you in respect of any losses arising out of any event or events beyond our reasonable control.</li>
                      <li>We will not be liable to you in respect of any business losses, including (without limitation) loss of or damage to profits, income, revenue, use, production, anticipated savings, business, contracts, commercial opportunities, or goodwill.</li>
                      <li>We will not be liable to you in respect of any loss or corruption of any data, database, or software.</li>
                      <li>We will not be liable to you in respect of any special, indirect, or consequential loss or damage.</li>
                      <li>You accept that we have an interest in limiting the personal liability of our officers and employees and, having regard to that interest, you acknowledge that we are a limited liability entity; you agree that you will not bring any claim personally against our officers or employees in respect of any losses you suffer in connection with the Cloud Service or these terms and conditions (this will not, of course, limit or exclude the liability of the limited liability entity itself for the acts and omissions of our officers and employees).</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Breaches of these Terms and Conditions</b>
                    <ol>
                      <li>Without prejudice to our other rights under these terms and conditions, if you breach these terms and conditions in any way, or if we reasonably suspect that you have breached these terms and conditions in any way, we may:
                        <ol>
                          <li>Send you one or more formal warnings;</li>
                          <li>Temporarily suspend your access to our Cloud Service;</li>
                          <li>Permanently prohibit you from accessing our Cloud Service;</li>
                          <li>Block computers using your IP address from accessing our Cloud Service;</li>
                          <li>Contact any or all of your internet service providers and request that they block your access to our Cloud Service;</li>
                          <li>Commence legal action against you, whether for breach of contract or otherwise; and/or</li>
                          <li>Suspend or delete your account on our Cloud Service.</li>
                        </ol>
                      </li>
                      <li>Where we suspend or prohibit or block your access to our Cloud Service or a part of our Cloud Service, you must not take any action to circumvent such suspension or prohibition or blocking (including without limitation creating and/or using a different account).</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Variation</b>
                    <ol>
                      <li>We may revise these terms and conditions from time to time.</li>
                      <li>The revised terms and conditions shall apply to the use of our Cloud Service from the date of publication of the revised terms and conditions on the Cloud Service, and you hereby waive any right you may otherwise have to be notified of, or to consent to, revisions of these terms and conditions. OR We will give you written notice of any revision of these terms and conditions, and the revised terms and conditions will apply to the use of our Cloud Service from the date that we give you such notice; if you do not agree to the revised terms and conditions, you must stop using our Cloud Service.</li>
                      <li>If you have given your express agreement to these terms and conditions, we will ask for your express agreement to any revision of these terms and conditions; and if you do not give your express agreement to the revised terms and conditions within such period as we may specify, we will disable or delete your account on the Cloud Service, and you must stop using the Cloud Service.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Assignment</b>
                    <ol>
                      <li>You hereby agree that we may assign, transfer, sub-contract or otherwise deal with our rights and/or obligations under these terms and conditions.</li>
                      <li>You may not without our prior written consent assign, transfer, sub-contract, or otherwise deal with any of your rights and/or obligations under these terms and conditions.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Severability</b>
                    <ol>
                      <li>If a provision of these terms and conditions is determined by any court or other competent authority to be unlawful and/or unenforceable, the other provisions will continue in effect.</li>
                      <li>If any unlawful and/or unenforceable provision of these terms and conditions would be lawful or enforceable if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Third-party Rights</b>
                    <ol>
                      <li>A contract under these terms and conditions is for our benefit and your benefit and is not intended to benefit or be enforceable by any third party.</li>
                      <li>The exercise of the parties' rights under a contract under these terms and conditions is not subject to the consent of any third party.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Entire Agreement</b>
                    <ol>
                      <li>Subject to Section 12.1, these terms and conditions, together with our privacy policy, shall constitute the entire agreement between you and us in relation to your use of our Cloud Service and shall supersede all previous agreements between you and us in relation to your use of our Cloud Service.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Law and Jurisdiction</b>
                    <ol>
                      <li>These terms and conditions shall be governed by and construed in accordance with Indian Law.</li>
                      <li>Any disputes relating to these terms and conditions shall be subject to the exclusive jurisdiction of the courts of India.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Pricing and Payment</b>
                    <ol>
                      <li>Prices throughout the Cloud Service are quoted in Indian Rupees (INR), and payment can only be accepted in Indian Rupees. Tax will be charged according to Goods Service Tax (GST).</li>
                      <li>In the case of international credit cards, the transaction amount will be converted to INR before the payment is accepted. Currency conversion charges may apply based on your credit card policy.</li>
                      <li>Your payment card will be debited for your order on the day we send you the formal order confirmation.</li>
                    </ol>
                  </li>
                </ol>
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleClickCloseDevTermsConditions} style={{color:"white", background:"#3f51b5"}} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* //End */}
        
        {/* Privacy Policy Dialog Starts Here */}
        <div>
          <Dialog onClose={handleClosePrivacyPolicy} aria-labelledby="customized-dialog-title" open={privacyPolicyOpen} style={{zIndex:"999999"}}>
            <DialogTitle id="customized-dialog-title" style={{textAlign:"center"}}>
            <b>Privacy Policy</b>
            </DialogTitle>
            <DialogContent dividers>
              <Typography variant="h6" component="h2" gutterBottom>
                <ol>
                  <li>
                    <b>Introduction</b>
                    <ol>
                      <li>We (ZKTeco Global) are committed to safeguarding the privacy of our cloud visitors and service users.</li>
                      <li>This policy applies where we are acting as a data controller with respect to the personal data of our cloud service visitors and service users; in other words, where we determine the purposes and means of the processing of that personal data.</li>
                      <li>We use cookies on our cloud service. As those cookies are not strictly necessary for the provision of our services, we will ask you to consent to our use of cookies when you first visit our cloud service.</li>
                      <li>Our cloud service incorporates privacy controls which affect how we will process your personal data.</li>
                      <li>In this policy, "we", "us" and "our" refer to <i>ZKTeco Global</i>.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Credit</b>
                    <ol>
                      <li>This document was created using a template from SEQ Legal.<br />
                        <a href="https://seqlegal.com/free-legal-documents/privacy-policy">https://seqlegal.com/free-legal-documents/privacy-policy</a>
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>How We Use Your Personal Data</b>
                    <ol>
                      <li>In Section 3, we have set out:
                        <ol>
                          <li>The general categories of personal data that we may process.</li>
                          <li>In the case of personal data that we did not obtain directly from you, the source, and specific categories of that data.</li>
                          <li>The purposes for which we may process personal data.</li>
                          <li>The legal bases of the processing.</li>
                        </ol>
                      </li>
                      <li>We may process data about your use of our cloud services <b>"Usage Data"</b>. The usage data may include your IP address, geographical location, browser type, and version, operating system, referral source, length of visit, page views, and cloud service navigation paths, as well as information about the timing, frequency, and pattern of your service use. The source of the usage data is our analytics tracking system. This usage data may be processed for the purposes of analyzing the use of the services. The legal basis for this processing is consent.</li>
                      <li>We may process your cloud service user account data <b>("Account Data")</b>. The account data may include your name and email address. The source of the account data is you or your employer. The account data may be processed for the purposes of operating our cloud service, providing our services, ensuring the security of our cloud service and services, maintaining back-ups of our databases, and communicating with you. The legal basis for this processing is consent, namely the proper administration of our cloud service and business.</li>
                      <li>We may process information that you post for publication on our cloud service or through our services <b>("Publication Data")</b>. The publication data may be processed for the purposes of enabling such publication and administering our cloud service and services. The legal basis for this processing is namely the proper administration of our cloud service and business.</li>
                      <li>We may process information contained in any enquiry you submit to us regarding services <b>("Enquiry Data")</b>. The enquiry data may be processed for the purposes of offering, marketing, and selling relevant services to you. The legal basis for this processing is the proper administration of our cloud service and business.</li>
                      <li>We may process information relating to transactions, including purchases of services, that you enter with us, and/or through our cloud service <b>("Transaction Data")</b>. The transaction data may include your contact details, your card details, and the transaction details. The source of the transaction data is you and/or our payment services provider. The transaction data may be processed for the purpose of supplying the purchased services and keeping proper records of those transactions. The legal basis for this processing is the performance of a contract between you and us and/or taking steps, at your request, to enter into such a contract; providing that, if you are not the person contracting with us, the legal basis for this processing is our legitimate interests, namely the proper administration of our cloud service and business.</li>
                      <li>We may process information that you provide to us for the purpose of subscribing to our email notifications and/or newsletters <b>("Notification Data")</b>. The notification data may be processed for the purposes of sending you the relevant notifications and/or newsletters. The legal basis for this processing is consent OR communications with our cloud service visitors and service users.</li>
                      <li>We may process any of your personal data [Personal details (e.g. name, contact details including, address, date of birth, documents such as identity card/passport details/Aadhaar details/PAN/Voter ID/driving license, and/or education details) provided by you to us] identified in this policy where necessary for the establishment, exercise or defense of legal claims, whether in court proceedings or an administrative or out-of-court procedure. The legal basis for this processing is our legitimate interests, namely the protection and assertion of our legal rights, your legal rights, and the legal rights of others.</li>
                      <li>We may process any of your personal data identified in this policy where necessary for the purposes of obtaining or maintaining insurance coverage, managing risks, or obtaining professional advice. The legal basis for this processing is our legitimate interests, namely the proper protection of our business against risks.</li>
                      <li>In addition to the specific purposes for which we may process your personal data set out in this Section 3, we may also process any of your personal data where such processing is necessary for compliance with a legal obligation to which we are subject, or in order to protect your vital interests or the vital interests of another natural person.</li>
                      <li>Please do not supply any other person's personal data to us, unless we prompt you to do so.</li>
                      <li>Information obtained from your mobile device by way of using our app, if any like device location, communication information including contacts and call logs, device information (including storage, model, mobile network), transactional and promotional SMS/app notifications.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Providing Your Personal Data to Others</b>
                    <ol>
                      <li>We may disclose your personal data to our insurers and/or professional advisers insofar as reasonably necessary for the purposes of obtaining or maintaining insurance coverage, managing risks, obtaining professional advice, or the establishment, exercise, or defense of legal claims, whether in court proceedings or an administrative or out-of-court procedure.</li>
                      <li>Your personal data held in our cloud service database will be stored on the servers of our hosting services providers identified at <i>easytimepro.in</i>.</li>
                      <li>In addition to the specific disclosures of personal data set out in this Section 4, we may disclose your personal data where such disclosure is necessary for compliance with a legal obligation to which we are subject, or in order to protect your vital interests or the vital interests of another natural person. We may also disclose your personal data where such disclosure is necessary for the establishment, exercise, or defense of legal claims, whether in court proceedings or in an administrative or out-of-court procedure.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>International Transfers of Your Personal Data</b>
                    <ol>
                      <li>In Section 5, we provide information about the circumstances in which your personal data may be transferred to countries outside your location.</li>
                      <li>The hosting facilities for our cloud service are situated in India. The Regulatory Commission has made an "adequacy decision" with respect to the data protection laws of each country. Transfers to countries will be protected by appropriate safeguards, namely the use of standard data protection clauses adopted or approved by the Regulatory Commission.</li>
                      <li>You acknowledge that personal data that you submit for publication through our cloud service or services may be available, via the internet, around the world. We cannot prevent the use (or misuse) of such personal data by others.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Retaining and Deleting Personal Data</b>
                    <ol>
                      <li>Section 6 sets out our data retention policies and procedure, which are designed to help ensure that we comply with our legal obligations in relation to the retention and deletion of personal data.</li>
                      <li>Personal data that we process for any purpose or purposes shall not be kept for longer than is necessary for that purpose or those purposes.</li>
                      <li>We will retain your personal data as follows:
                        <ol>
                          <li>As long as the purpose for its usage exists, after which the same is disposed of by us except for any record retention required as per applicable law.</li>
                          <li>The provisions of various laws require your transaction logs to be stored for longer periods post the deletion of an account. Further, in the event of the pendency of any legal/regulatory proceeding or receipt of any legal and/or regulatory direction to that effect, we may be required by the law of the land to retain your Personal Data for longer periods.</li>
                        </ol>
                      </li>
                      <li>Notwithstanding the other provisions of this Section 6, we may retain your personal data where such retention is necessary for compliance with a legal obligation to which we are subject, or in order to protect your vital interests or the vital interests of another natural person.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Your Rights</b>
                    <ol>
                      <li>In Section 7, we have listed the rights that you have under data protection law.</li>
                      <li>Your principal rights under data protection law are:
                        <ol>
                          <li><b>The right to access</b> - You can ask for copies of your personal data.</li>
                          <li><b>The right to rectification</b> - You can ask us to rectify inaccurate personal data and to complete incomplete personal data.</li>
                          <li><b>The right to erasure</b> - You can ask us to erase your personal data.</li>
                          <li><b>The right to restrict processing</b> - You can ask users to restrict the processing of your personal data.</li>
                          <li><b>The right to object to processing</b> - You can object to the processing of your personal data.</li>
                          <li><b>The right to data portability</b> - You can ask that we transfer your personal data to another organization or to you.</li>
                          <li><b>The right to complain to a supervisory authority</b> - You can complain about our processing of your personal data; and</li>
                          <li><b>The right to withdraw consent</b> - To the extent that the legal basis of our processing of your personal data is consent, you can withdraw that consent.</li>
                        </ol>
                      </li>
                      <li>You may exercise any of your rights in relation to your personal data by written notice to us.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>About Cookies</b>
                    <ol>
                      <li>A cookie is a file containing an identifier (a string of letters and numbers) that is sent by a web server to a web browser and is stored by the browser. The identifier is then sent back to the server each time the browser requests a page from the server.</li>
                      <li>Cookies may be either "persistent" cookies or "session" cookies: a persistent cookie will be stored by a web browser and will remain valid until its set expiry date unless deleted by the user before the expiry date; a session cookie, on the other hand, will expire at the end of the user session, when the web browser is closed.</li>
                      <li>Cookies do not typically contain any information that personally identifies a user, but personal data that we store about you may be linked to the information stored in and obtained from cookies.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Cookies That We Use</b>
                    <ol>
                      <li>We use cookies for the following purposes:
                        <ol>
                          <li><b>Authentication and Status</b> - We use cookies to identify you when you visit our cloud service and as you navigate our cloud service, and to determine if you are logged into the cloud service.</li>
                          <li><b>Personalization</b> - We use cookies to store information about your preferences and to personalize the cloud service for you.</li>
                          <li><b>Security</b> - We use cookies as an element of the security measures used to protect user accounts, including preventing fraudulent use of login credentials, and to protect our cloud service and services generally.</li>
                          <li><b>Advertising</b> - We use cookies to help us to display advertisements that will be relevant to you.</li>
                          <li><b>Analysis</b> - We use cookies to help us to analyze the use and performance of our services; and</li>
                          <li><b>Cookie Consent</b> - We use cookies to store your preferences in relation to the use of cookies more generally.</li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Cookies Used by Our Service Providers</b>
                    <ol>
                      <li>Our service providers use cookies and those cookies may be stored on your computer when you visit our cloud service.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Managing Cookies</b>
                    <ol>
                      <li>Most browsers allow you to refuse to accept cookies and to delete cookies. The methods for doing so vary from browser to browser, and from version to version. You can however obtain up-to-date information about blocking and deleting cookies via these links:
                        <ol>
                          <li><a href="https://support.google.com/chrome/answer/95647">https://support.google.com/chrome/answer/95647</a>  (Chrome);</li>
                          <li><a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-cloud service-preferences">https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-cloud service-preferences</a> (Firefox);</li>
                          <li><a href="https://help.opera.com/en/latest/security-and-privacy/">https://help.opera.com/en/latest/security-and-privacy/</a> (Opera);</li>
                          <li><a href="https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies">https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies</a> (Internet Explorer);</li>
                          <li><a href="https://support.apple.com/en-gb/guide/safari/manage-cookies-and-cloud service-data-sfri11471/mac">https://support.apple.com/en-gb/guide/safari/manage-cookies-and-cloud service-data-sfri11471/mac</a> (Safari); and</li>
                          <li><a href="https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy">https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy</a> (Edge).</li>
                        </ol>
                      </li>
                      <li>Blocking all cookies will have a negative impact upon the usability of many cloud services.</li>
                      <li>If you block cookies, you will not be able to use all the features on our cloud service.</li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>Amendments</b>
                    <ol>
                      <li>We may update this policy from time to time by publishing a new version of our cloud service.</li>
                      <li>You should check this page occasionally to ensure you are happy with any changes to this policy.</li>
                      <li>We will notify you of significant changes to this policy by email.</li>
                    </ol>
                  </li>
                </ol>
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button autoFocus variant="outlined" style={{color:"white", background:"#3f51b5"}} onClick={handleClosePrivacyPolicy} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* //End */}
      </footer>
    </div>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool
};
